'use client';

import type { ReactNode } from 'react';
import { InView } from '@/components/motion/InView';
import styles from './LegalSection.module.css';

interface LegalSectionProps {
  id?: string;
  title: string;
  children: ReactNode;
}

export function LegalSection({ id, title, children }: LegalSectionProps) {
  return (
    <InView y={24} duration={0.65}>
      <section id={id} className={styles.section}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.content}>{children}</div>
      </section>
    </InView>
  );
}
